module.exports = __webpack_public_path__ + "static/media/calendario-planta.a0fb3e1c.png";